module.exports = __webpack_public_path__ + "static/media/without-color.527b5cfa.svg";